import React from 'react';
import { Skeleton as SkeletonUI } from 'components/ui/skeleton';

export const Skeleton: React.FC = () => {
  return (
    <section>
      <div className="w-full mb-4 flex flex-col md:flex-col gap-3 items-start justify-between">
        <SkeletonUI className="h-10 w-full" />
        <SkeletonUI className="h-7 w-full" />
        <SkeletonUI className="h-7 w-full" />
        <SkeletonUI className="h-7 w-full" />
      </div>
    </section>
  );
};
